import {Album} from './album';

export class Galerie {
    id: number;
    libelle: string;
    photo: string;
    album: Album;
}
